import { NavigateFunction } from "react-router-dom";
import { toAppUrl, toMarketingUrl } from "../constants/siteDomains";

function isAbsoluteUrl(url: string): boolean {
  return /^https?:\/\//i.test(url);
}

/** Navega para rota do app (cross-domain quando necessário). */
export function goToApp(path: string, navigate?: NavigateFunction): void {
  const url = toAppUrl(path);
  if (isAbsoluteUrl(url)) {
    window.location.assign(url);
    return;
  }
  navigate?.(path);
}

/** Navega para rota do site institucional (cross-domain quando necessário). */
export function goToMarketing(path: string, navigate?: NavigateFunction): void {
  const url = toMarketingUrl(path);
  if (isAbsoluteUrl(url)) {
    window.location.assign(url);
    return;
  }
  navigate?.(path);
}

export { toAppUrl, toMarketingUrl };
